import { SharedService } from './shared/shared.service';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { environment } from '../environments/environment';

@Component( {
  selector: 'dynamica-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    TranslatePipe,
    RouterOutlet,
    Toast
  ]
} )
export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'Dynamica Smart Rates';
  show = false;
  isLoading$?: Subscription;
  currentLang = 'en';
  languages = ['de', 'en'];
  env = environment;

  constructor(
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.translate.addLangs( this.languages );
    this.translate.setFallbackLang( this.currentLang );
    this.translate.use( this.currentLang );
  }

  ngAfterViewInit(): void {
    this.isLoading$ = this.sharedService.loaderSubject
      .subscribe( ( state: any ) => {
        this.show = state.show;
        this.cdr.detectChanges();
      } );
  }

  ngOnDestroy(): void {
    this.isLoading$?.unsubscribe();
  }
}
